<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        再組版
      </template>

      <template v-slot:content>
        <template v-if="request && !request.message">
          <div>
            <v-row class="mx-6">
              <v-col cols="6">
                <v-text-field
                  v-model="request.code"
                  label="発行コード"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-6">
              <v-col cols="6">
                <v-text-field
                  v-model="sheetName"
                  label="テスト名"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-6">
              <v-col cols="6">
                <v-text-field
                  v-model="request.preset_name"
                  label="プリセット名"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-6">
              <v-col cols="6">
                <v-text-field
                  v-model="request.school_name"
                  label="学校"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-6">
              <v-col cols="6">
                <v-text-field
                  v-model="request.subject_name"
                  label="教科"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-6">
              <v-col cols="6">
                <v-text-field
                  v-model="request.grade_name"
                  label="教科"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-btn class="mt-6 ml-6" small color="secondary" :dark="submitFlg" @click.stop="submit" :disabled="!submitFlg">実行</v-btn>
          </div>
        </template>
        <template v-else-if="request">
          <p style="font-size: 14px">{{request.message}}</p>
        </template>
      </template>
    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import { saveAs } from 'file-saver'

export default {
  components: {
    VBaseCard,
  },

  data () {
    return {
      request: {},
      sheetName: '',
      submitFlg: true,
    }
  },

  async mounted(){
    const res = await this.$axios.get(`/api/v1/admin/requests/${this.$route.params.request_code}`)
    this.request = res.data
    this.sheetName = this.request.sheet_name
  },

  methods: {
    async submit(){
      this.$app.$refs.loading.open({type: 'normal', message: '処理中です。少々お待ちください。'})
      this.submitFlg = false
      const res = await this.$axios.get(`/api/v1/admin/requests/${this.request.id}/recompose?sheet_name=${this.sheetName}`, {responseType: 'blob', dataType: 'binary'})
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
      this.submitFlg = true
      this.$app.$refs.loading.close()
    },
    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      return fileName
    },
  },
}
</script>

<style lang="stylus" scoped>

.select
  font-size: 11px !important;
</style>
